import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class DataService {
  public items: any = [];

  constructor() {
    this.items = [
      { title: "Baragoi", isChecked: false },
      { title: "Bungoma", isChecked: false },
{ title: "Busia", isChecked: false },
{ title: "Butere", isChecked: false },
{ title: "Dadaab", isChecked: false },
{ title: "Diani Beach", isChecked: false },
{ title: "Eldoret", isChecked: false },
{ title: "Emali", isChecked: false },
{ title: "Embu", isChecked: false },
{ title: "Garissa", isChecked: false },
{ title: "Gede", isChecked: false },
{ title: "Hola", isChecked: false },
{ title: "Homa Bay", isChecked: false },
{ title: "Isiolo", isChecked: false },
{ title: "Kitui", isChecked: false },
{ title: "Kibwezi", isChecked: false },
{ title: "Kajiado", isChecked: false },
{ title: "Kakamega", isChecked: false },
{ title: "Kakuma", isChecked: false },
{ title: "Kapenguria", isChecked: false },
{ title: "Kericho", isChecked: false },
{ title: "Keroka", isChecked: false },
{ title: "Kiambu", isChecked: false },
{ title: "Kilifi", isChecked: false },
{ title: "Kisii", isChecked: false },
{ title: "Kisumu", isChecked: false },
{ title: "Kitale", isChecked: false },
{ title: "Lamu", isChecked: false },
{ title: "Langata", isChecked: false },
{ title: "Litein", isChecked: false },
{ title: "Lodwar", isChecked: false },
{ title: "Lokichoggio", isChecked: false },
{ title: "Londiani", isChecked: false },
{ title: "Loyangalani", isChecked: false },
{ title: "Machakos", isChecked: false },
{ title: "Makindu", isChecked: false },
{ title: "Malindi", isChecked: false },
{ title: "Mandera", isChecked: false },
{ title: "Maralal", isChecked: false },
{ title: "Marsabit", isChecked: false },
{ title: "Meru", isChecked: false },
{ title: "Mombasa", isChecked: false },
{ title: "Moyale", isChecked: false },
{ title: "Mumias", isChecked: false },
{ title: "Muranga", isChecked: false },
{ title: "Mutomo", isChecked: false },
{ title: "Nairobi", isChecked: false },
{ title: "Naivasha", isChecked: false },
{ title: "Nakuru", isChecked: false },
{ title: "Namanga", isChecked: false },
{ title: "Nanyuki", isChecked: false },
{ title: "Naro Moru", isChecked: false },
{ title: "Narok", isChecked: false },
{ title: "Nyahururu", isChecked: false },
{ title: "Nyeri", isChecked: false },
{ title: "Ruiru", isChecked: false },
{ title: "Shimoni", isChecked: false },
{ title: "Takaungu", isChecked: false },
{ title: "Thika", isChecked: false },
{ title: "Vihiga", isChecked: false },
{ title: "Voi", isChecked: false },
{ title: "Wajir", isChecked: false },
{ title: "Watamu", isChecked: false },
{ title: "Webuye", isChecked: false },
{ title: "Wote", isChecked: false },
{ title: "Wundanyi", isChecked: false }

    ];
  }

  filterItems(searchTerm) {
    return this.items.filter(item => {
      return item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }
}